import React from 'react';
import Projects from './Projects';
import "./projects.css";
import { BsGithub } from "react-icons/bs";

const Portfolio = () => {
  const handleViewMoreClick = () => {
    window.open('https://github.com/ashkanazimei', '_blank');
  };
  
  return (
    <section className="portfolio section" id="portfolio">
        <h2 className="section__title">Github Projects</h2>
        
        <div style={{ 
          display: 'flex', 
          justifyContent: 'center', 
          marginBottom: 'var(--mb-2)'
        }}>
          <div 
            className="section__subtitle"
            onClick={handleViewMoreClick}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              padding: '0.5rem 1rem',
              borderRadius: '0.5rem'
            }}
            onMouseEnter={(e) => {
              e.target.style.color = 'var(--first-color)';
              e.target.style.transform = 'translateY(-2px)';
            }}
            onMouseLeave={(e) => {
              e.target.style.color = '';
              e.target.style.transform = '';
            }}
          >
            view more on 
            <span style={{ display: 'flex', alignItems: 'center', gap: '0.25rem' }}>
              <BsGithub /> GitHub
            </span>
          </div>
        </div>

        <Projects />
    </section>
  );
}

export default Portfolio;